(() => {
const $973b254601fecd3f$var$$ = jQuery;
const $973b254601fecd3f$var$_window = $973b254601fecd3f$var$$(window);
const $973b254601fecd3f$var$Menu = {
    $dom: {
        container: $973b254601fecd3f$var$$("#site-navigation"),
        menu_toggle: $973b254601fecd3f$var$$(".menu-toggle"),
        body: $973b254601fecd3f$var$$("body"),
        menu: undefined,
        links: undefined,
        sub_menus: undefined
    },
    vars: {
        activated_screen_resolution: 1199,
        show_arrows_on_desktop: false
    },
    initDom: function() {
        $973b254601fecd3f$var$Menu.$dom.menu = $973b254601fecd3f$var$Menu.$dom.container.find("ul").eq(0);
        $973b254601fecd3f$var$Menu.$dom.links = $973b254601fecd3f$var$Menu.$dom.menu.find("a");
        $973b254601fecd3f$var$Menu.$dom.sub_menus = $973b254601fecd3f$var$Menu.$dom.menu.find("ul");
    },
    appendArrows: function() {
        if ($973b254601fecd3f$var$_window.width() <= $973b254601fecd3f$var$Menu.vars.activated_screen_resolution || $973b254601fecd3f$var$Menu.vars.show_arrows_on_desktop) {
            var items_has_children = $973b254601fecd3f$var$Menu.$dom.container.find("li.menu-item-has-children");
            items_has_children.each(function() {
                if ($973b254601fecd3f$var$$(this).find(".arrow-toggle").length > 0) return;
                var $parent = this;
                var $arrow = $973b254601fecd3f$var$$("<span class='arrow-toggle'><span class='arrow-toggle--icon'></span></span>");
                $973b254601fecd3f$var$$(this).prepend($arrow);
                $arrow.on("click", function() {
                    $973b254601fecd3f$var$$($parent).toggleClass("expandeds");
                    $973b254601fecd3f$var$$($parent).find("> .sub-menu").slideToggle(500);
                });
            });
        } else $973b254601fecd3f$var$$(".arrow-toggle").remove();
    },
    toggleMenu: function() {
        $973b254601fecd3f$var$Menu.$dom.menu_toggle.on("click", function(e) {
            $973b254601fecd3f$var$Menu.$dom.menu_toggle.toggleClass("is-active");
            $973b254601fecd3f$var$Menu.$dom.body.toggleClass("menu-active");
            $973b254601fecd3f$var$Menu.$dom.container.toggleClass("toggled");
            e.stopPropagation();
        });
    },
    closeMenu: function() {
        if ($973b254601fecd3f$var$$(this).attr("href") != "#" && $973b254601fecd3f$var$$(this).attr("href") != "") {
            $973b254601fecd3f$var$Menu.$dom.body.removeClass("menu-active");
            $973b254601fecd3f$var$Menu.$dom.menu_toggle.removeClass("is-active");
            $973b254601fecd3f$var$Menu.$dom.container.removeClass("toggled");
        }
    },
    bindScrollResize: function() {
        $973b254601fecd3f$var$_window.on("resize", function() {
            $973b254601fecd3f$var$Menu.appendArrows();
        });
    },
    bindClicks: function() {
        $973b254601fecd3f$var$$(document).on("click", $973b254601fecd3f$var$Menu.closeMenu);
        $973b254601fecd3f$var$Menu.$dom.links.on("click", $973b254601fecd3f$var$Menu.closeMenu);
        $973b254601fecd3f$var$Menu.toggleMenu();
        $973b254601fecd3f$var$Menu.$dom.container.find("> div").click(function(e) {
            e.stopPropagation();
        });
    },
    init: function() {
        $973b254601fecd3f$var$Menu.initDom();
        $973b254601fecd3f$var$Menu.appendArrows();
        $973b254601fecd3f$var$Menu.bindClicks();
        $973b254601fecd3f$var$Menu.bindScrollResize();
    }
};
var $973b254601fecd3f$export$2e2bcd8739ae039 = $973b254601fecd3f$var$Menu;


const $cb6de554e11ef79b$var$$ = jQuery;
const $cb6de554e11ef79b$var$Theme = {
    dom: {
        shareLink: $cb6de554e11ef79b$var$$(".share-buttons a"),
        smoothScrollLinks: $cb6de554e11ef79b$var$$('a[href*="#"]')
    },
    /**************************************************
    * Share links
    **************************************************/ share: function() {
        $cb6de554e11ef79b$var$$(".share-buttons a").on("click", function(e) {
            if (!$cb6de554e11ef79b$var$$(this).hasClass("btn-email")) {
                e.preventDefault();
                $cb6de554e11ef79b$var$Theme.PopupCenter($cb6de554e11ef79b$var$$(this).attr("href"), $cb6de554e11ef79b$var$$(this).attr("title"), 500, 300);
            }
        });
    },
    /**************************************************
    * Share links popup
    **************************************************/ PopupCenter: function(url, title, w, h) {
        // Fixes dual-screen position                         Most browsers      Firefox
        var dualScreenLeft = window.screenLeft != undefined ? window.screenLeft : screen.left;
        var dualScreenTop = window.screenTop != undefined ? window.screenTop : screen.top;
        var width = window.innerWidth ? window.innerWidth : document.documentElement.clientWidth ? document.documentElement.clientWidth : screen.width;
        var height = window.innerHeight ? window.innerHeight : document.documentElement.clientHeight ? document.documentElement.clientHeight : screen.height;
        var left = width / 2 - w / 2 + dualScreenLeft;
        var top = height / 2 - h / 2 + dualScreenTop;
        var newWindow = window.open(url, title, "scrollbars=yes, width=" + w + ", height=" + h + ", top=" + top + ", left=" + left);
        // Puts focus on the newWindow
        if (window.focus) newWindow.focus();
    },
    /**************************************************
    * Smooth scroll
    ***************************************************/ smooth_scroll: function() {
        $cb6de554e11ef79b$var$Theme.dom.smoothScrollLinks// Remove links that don't actually link to anything
        .not('[href="#"]').not('[href="#0"]').click(function(event) {
            // On-page links
            if (location.pathname.replace(/^\//, "") == this.pathname.replace(/^\//, "") && location.hostname == this.hostname) {
                // Figure out element to scroll to
                var target = $cb6de554e11ef79b$var$$(this.hash);
                target = target.length ? target : $cb6de554e11ef79b$var$$("[name=" + this.hash.slice(1) + "]");
                // Does a scroll target exist?
                if (target.length) {
                    // Only prevent default if animation is actually gonna happen
                    event.preventDefault();
                    $cb6de554e11ef79b$var$$("html, body").animate({
                        scrollTop: target.offset().top
                    }, 1000, function() {
                        // Callback after animation
                        // Must change focus!
                        var $target = $cb6de554e11ef79b$var$$(target);
                        $target.focus();
                        if ($target.is(":focus")) // Checking if the target was focused
                        return false;
                        else {
                            $target.attr("tabindex", "-1"); // Adding tabindex for elements not focusable
                            $target.focus(); // Set focus again
                        }
                    });
                }
            }
        });
    },
    /**************************************************
    * Fix Height on smaller devices
    **************************************************/ fix_mobile_height: function() {
        let vh = window.innerHeight * 0.01;
        document.documentElement.style.setProperty('--vh', `${vh}px`);
        window.addEventListener('resize', ()=>{
            let vh = window.innerHeight * 0.01;
            document.documentElement.style.setProperty('--vh', `${vh}px`);
        });
    },
    /**************************************************
    * Initial all theme functions
    **************************************************/ init: function() {
        $cb6de554e11ef79b$var$Theme.share();
        $cb6de554e11ef79b$var$Theme.smooth_scroll();
        $cb6de554e11ef79b$var$Theme.fix_mobile_height();
    }
};
var $cb6de554e11ef79b$export$2e2bcd8739ae039 = $cb6de554e11ef79b$var$Theme;


const $ee595bbced94e3de$var$$ = jQuery;
const $ee595bbced94e3de$var$AssemblyDocumentation = {
    init: function() {
        const items = $ee595bbced94e3de$var$$(".assembly-documentation--contnet");
        if (!items.length) return;
        // PRVI OTVOREN
        const firstItem = items.first();
        firstItem.addClass("active");
        firstItem.find(".documents").slideDown(0);
        items.each(function() {
            const item = $ee595bbced94e3de$var$$(this);
            const toggle = item.find(".title-wrapper");
            const content = item.find(".documents");
            toggle.on("click", function() {
                const activeItem = $ee595bbced94e3de$var$$(".assembly-documentation--contnet.active");
                if (!item.hasClass("active")) {
                    // zatvori prethodno otvoren
                    if (activeItem.length) activeItem.removeClass("active").find(".documents").slideUp();
                    // otvori kliknuti
                    item.addClass("active");
                    content.slideDown();
                } else {
                    // zatvori ako je već otvoren
                    item.removeClass("active");
                    content.slideUp();
                }
            });
        });
    }
};
var $ee595bbced94e3de$export$2e2bcd8739ae039 = $ee595bbced94e3de$var$AssemblyDocumentation;


const $3d7dae9c7503d7c9$var$$ = jQuery;
const $3d7dae9c7503d7c9$var$HeaderScroll = {
    init: function() {
        const header = $3d7dae9c7503d7c9$var$$("#site-header");
        const hero = $3d7dae9c7503d7c9$var$$(".section-hero");
        if (!header.length || !hero.length) return;
        const updateHeader = ()=>{
            const heroBottom = hero.offset().top + hero.outerHeight();
            const scrollTop = $3d7dae9c7503d7c9$var$$(window).scrollTop();
            if (scrollTop > heroBottom) header.addClass("scrolled");
            else header.removeClass("scrolled");
        };
        $3d7dae9c7503d7c9$var$$(window).on("scroll resize", updateHeader);
        // poziv odmah na load
        updateHeader();
    }
};
var $3d7dae9c7503d7c9$export$2e2bcd8739ae039 = $3d7dae9c7503d7c9$var$HeaderScroll;


(0, $973b254601fecd3f$export$2e2bcd8739ae039).init();
(0, $cb6de554e11ef79b$export$2e2bcd8739ae039).init();
(0, $ee595bbced94e3de$export$2e2bcd8739ae039).init();
(0, $3d7dae9c7503d7c9$export$2e2bcd8739ae039).init();

})();
//# sourceMappingURL=main.js.map
